import { useRCAMainStyles } from "../../../RCA.styles";
import { RCASettingsEntity } from "entities/RCA/RCASettingsEntity/RCASettingsEntity";
import RCASettingsAccordion from "../../component/RCASettingsAccordion";
import useRolesPermissions from "hooks/useRolesPermissions";
import { useMemo } from "react";
import { ASSIGNABLE_USER_TYPE_IDS } from "constants/constants";

export const RCATriggersSetting = () => {
    const mainClasses = useRCAMainStyles();
    const { RCA_PERMISSIONS } = useRolesPermissions();
    // Was `typeId !== OSORNOADMINISTRATOR || typeId !== OPERATOR`, which is always true (a value
    // cannot equal both), so every user type reached this dropdown. Restored to the evident intent.
    const { rcaSettings, apolloQueryError, loading, refetch } =
        RCASettingsEntity.GetRCASettings(ASSIGNABLE_USER_TYPE_IDS);
    const userCanEdit = useMemo(() => RCA_PERMISSIONS?.settings?.canEdit, [RCA_PERMISSIONS]);

    return (
        <div>
            <div style={{ padding: 0 }} className={mainClasses.contentWrapper}>
                {rcaSettings.map((rcaSetting, index) => (
                    <RCASettingsAccordion
                        refetch={refetch}
                        key={rcaSetting.production_line_id}
                        defaultExpanded={index === 0}
                        loading={loading}
                        apolloQueryError={apolloQueryError}
                        rcaSetting={rcaSetting}
                        canEdit={userCanEdit}
                    />
                ))}
            </div>
        </div>
    );
};
